import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate

const AiVoiceAssistant = () => {
  const [listening, setListening] = useState(false);
  const [assistantText, setAssistantText] = useState('Hello! I am your AI assistant. How can I help you today?');
  const [voice, setVoice] = useState(null);
  const navigate = useNavigate(); // Initialize useNavigate

  const speak = (text) => {
    if (voice && text) {
      const utterance = new SpeechSynthesisUtterance(text);
      utterance.voice = voice;
      window.speechSynthesis.speak(utterance);
    }
  };

  useEffect(() => {
    // Initialize the SpeechSynthesis API for voice
    const synth = window.speechSynthesis;
    const voices = synth.getVoices();
    const assistantVoice = voices.find(v => v.lang === 'en-US') || voices[0]; // Select an English voice or fallback
    setVoice(assistantVoice);
    speak(assistantText); // Greet user
  }, [assistantText, speak]); // Include 'speak' in the dependency array

  const handleUserQuery = () => {
    if (!window.SpeechRecognition && !window.webkitSpeechRecognition) {
      alert("Speech Recognition is not supported in this browser.");
      return;
    }

    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    const recognition = new SpeechRecognition();
    recognition.lang = 'en-US';
    recognition.start();

    recognition.onstart = () => {
      setListening(true);
      setAssistantText("I'm listening... Please speak now.");
    };

    recognition.onspeechend = () => {
      recognition.stop();
      setListening(false);
    };

    recognition.onresult = (event) => {
      const transcript = event.results[0][0].transcript;
      processUserQuery(transcript);
    };

    recognition.onerror = (event) => {
      setAssistantText(`Error occurred: ${event.error}`);
      setListening(false);
    };
  };

  const processUserQuery = (query) => {
    setAssistantText(`You said: "${query}". Let me help you with that...`);

    // Here you can add commands based on the user's query
    if (query.toLowerCase().includes('register')) {
      speak("To register on our system, click on the 'Register' button and fill in your details.");
    } else if (query.toLowerCase().includes('login')) {
      speak("To log into your account, click on the 'Login' button and enter your credentials.");
    } else if (query.toLowerCase().includes('dashboard')) {
      speak("The dashboard allows you to manage your products, view user data, and more.");
    } else if (query.toLowerCase().includes('products')) {
      speak("Our products page showcases all our available items with user reviews.");
    } else {
      speak("I am sorry, I did not understand that. Please ask me about logging in, registering, the dashboard, or products.");
    }
  };

  const handleHomeClick = () => {
    navigate('/dashboard'); // Navigate to the dashboard route
  };

  return (
    <div className="ai-assistant">
      <h2 className="assistant-title">ButterFly Wings AI Voice Assistant</h2>
      <p className="assistant-text">{assistantText}</p>

      <button
        className={`listen-button ${listening ? 'listening' : ''}`}
        onClick={handleUserQuery}
      >
        {listening ? 'Listening...' : 'Ask a Question'}
      </button>

      <button className="home-button" onClick={handleHomeClick}>
        Home
      </button>

      <style jsx>{`
        .ai-assistant {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          background-color: black;
          color: #00FFFF;
          padding: 20px;
          border-radius: 10px;
          margin: 20px;
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
        }

        .assistant-title {
          font-size: 2rem;
          margin-bottom: 10px;
          color: #00FFFF;
        }

        .assistant-text {
          font-size: 1.2rem;
          margin-bottom: 20px;
          text-align: center;
        }

        .listen-button {
          background-color: #00FFFF;
          color: black;
          padding: 10px 20px;
          border: none;
          border-radius: 5px;
          cursor: pointer;
          font-size: 1.2rem;
          font-weight: bold;
          transition: transform 0.3s ease, background-color 0.3s ease;
          margin-bottom: 10px; /* Add some spacing */
        }

        .listen-button:hover {
          background-color: #009ACD;
        }

        .listen-button.listening {
          background-color: #FFD700;
        }

        .home-button {
          background-color: #00FFFF;
          color: black;
          padding: 10px 20px;
          border: none;
          border-radius: 5px;
          cursor: pointer;
          font-size: 1.2rem;
          font-weight: bold;
          transition: transform 0.3s ease, background-color 0.3s ease;
        }

        .home-button:hover {
          background-color: #009ACD;
        }
      `}</style>
    </div>
  );
};

export default AiVoiceAssistant;
